import {LOCALES} from "./locales"

export const messages = {
    [LOCALES.ENGLISH]:{
        ERROR:{
            
            '5041': 'You cannot move this organization to an organization category (this update is outside of your scope), please contact oms@ontario.ca',   
            '5042': 'You cannot move this organization to a cloned organization.',         
            '5043': 'A child organization cannot be moved to its current parent organization.',
            '5044': 'A child organization cannot be moved to itself.',
            '5045': 'A child organization cannot be moved to its child/descendant organization.',
            '5046': 'A top-level-organization cannot be moved to itself.',
            '5047': 'You must select a new category to move the top-level organization.',
            '5048': 'You cannot move an organization under a group category.',
            '5049': 'A Top-level organization cannot be moved to its child/descendant organization. Select another category/organization.',
            '5411': 'This value is too long. It should have 200 characters or fewer.',
            '5412': "Only the following special characters are allowed: & ( ) + / _ - '",

            '5511': "This value is too long. It should have 30 characters or fewer.",

            '5611' : 'Search on a generic job title and type in a prefix/suffix to create the full position/role title; otherwise, please contact the administrator.',
            '5612' : 'This value is too long. It should have 100 characters or fewer.',
            '5613' : "Only the following special characters are allowed: , & ( ) + / _ - '",
            '5614' : "Only one position can be checked as being Responsible for the organization, please uncheck the other position already identified as Responsible for the organization.",
            
            '2.1':  'You cannot create a relationship between an organization and itself.',
            '2.2':  'The indirect relationship already exists.',
            '2.3':  'Nested sharing is not supported. The shared organization is not allowed to contain any cloned child organizations.',
            '2.4':  'The shared organization can not be a top-level organization.',
            '2.5':  'An organization cannot be shared with any ancestors higher in the hierarchy or descendants lower in the hierarchy.',
            '2.6':  'You cannot share an organization with a different category.',           
            '2.11': 'Not allowed to share a unshared Org if any of its ancestors or descendants is shared or cloned.',
            '2.12': 'Not allowed to share a shared Org if any of its ancestors is shared or cloned.',         
            '2.13': 'You cannot create a relationship between a parent and child organization.',
            '2.14': 'You cannot create a relationship between a category and organization.'
        },
        INFO:{
            '1.1' : 'No records found',
            '1.2' : 'No associated organizations found',
            '2.1' : 'The current organization will be expired. An expired organization <b>CANNOT</b> be re-activated. Any indirect relationships to the organization will also be expired automatically. Are you sure you want to continue?',
            '2.2' : 'This organization cannot be expired. All associated positions, individuals and organizations must be removed first.',
            '2.3' : 'This organization cannot be expired because it is no longer in the system. Please refresh the page.',

            '3.3': 'You do not have permission to activate the HOME position.  {individualName} has a Secondment position outside of your scope. Please contact the appropriate ministry coordinator to remove the individual from the other assignment.',
            
            '4.1': 'The selected position(s) or role(s) will be expired. All related data will be lost. Are you sure you want to continue?',
            '5.1': 'Are you sure you want to add selected member(s)?',
            '5.2': 'The selected members will be removed. All related data will be lost. Are you sure you want to continue?',
        }
    }

}